// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    FiatAccountAPIModel,
    FiatAccountAPIModelFromJSON,
    FiatAccountAPIModelToJSON,
} from '../models';

/**
 * AccountsApi - interface
 * 
 * @export
 * @interface AccountsApiInterface
 */
export interface AccountsApiInterface {
    /**
     * Gets all fiat accounts for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApiInterface
     */
    getFiatAccountsRaw(): Promise<runtime.ApiResponse<Array<FiatAccountAPIModel>>>;

    /**
     * Gets all fiat accounts for a user
     */
    getFiatAccounts(): Promise<Array<FiatAccountAPIModel>>;

}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI implements AccountsApiInterface {

    /**
     * Gets all fiat accounts for a user
     */
    async getFiatAccountsRaw(): Promise<runtime.ApiResponse<Array<FiatAccountAPIModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FiatAccountAPIModelFromJSON));
    }

    /**
     * Gets all fiat accounts for a user
     */
    async getFiatAccounts(): Promise<Array<FiatAccountAPIModel>> {
        const response = await this.getFiatAccountsRaw();
        return await response.value();
    }

}
